import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_WEBHOOKS_HISTORY_ROUTE_NAME = Symbol('admin.webhooks-history');
export const AFFILIATE_WEBHOOKS_HISTORY_ROUTE_NAME = Symbol('affiliate.webhooks-history');

export const TRANSLATION_GROUP_ADMIN_WEBHOOKS_HISTORY = Symbol('admin.webhooks-history');
export const TRANSLATION_GROUP_AFFILIATES_WEBHOOKS_HISTORY = Symbol('affiliates.webhooks-history');

export const ADMIN_WEBHOOKS_HISTORY_LIST_ROUTE_NAME = Symbol('admin.webhooks-history.list');
export const AFFILIATE_WEBHOOKS_HISTORY_LIST_ROUTE_NAME = Symbol('affiliate.webhooks-history.list');

// Webhooks history list query
export const WEBHOOKS_HISTORY_LIST_QUERY_KEY = 'webhooks-history-list';
export const WEBHOOKS_HISTORY_LIST_API_URL = ':namespace/requests/list';

// Webhooks history download mutation
export const WEBHOOKS_HISTORY_DOWNLOAD_LIST_MUTATION_KEY = 'admin-webhooks-history-download';
export const WEBHOOKS_HISTORY_DOWNLOAD_LIST_API_URL = ':namespace/requests/download_report';

export const WEBHOOKS_HISTORY_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.REQUESTS_ALL, PermissionsList.affiliate.REQUESTS_SHOW),
  DOWNLOAD: new Permission(PermissionsList.admin.REQUESTS_ALL, PermissionsList.affiliate.REQUESTS_DOWNLOAD_REPORT),
};
